module.exports = __webpack_public_path__ + "static/media/ico-signout.debb9999.svg";